module.exports = __webpack_public_path__ + "static/media/hd-signature1.0d31511e.jpg";